import { call, put, takeLatest } from 'redux-saga/effects'
import {
  FETCH_ADMIN_LINKS,
  ADD_USER_LINK,
  FETCH_USER_LINKS,
  DELETE_USER_LINK,
  UPDATE_USER_LINK
} from './constants'
import {
  fetchAdminLinks,
  addUserLink,
  fetchUserLinks,
  deleteUserLink,
  updateUserLink
} from './actions'
import {
  apiFetchAdminLinks,
  addUserLinkApi,
  apiFetchUserLinks,
  deleteUserLinkApi,
  updateUserLinkApi
} from './services'

function* fetchAdminLinksWorker(action) {
  try {
    const response = yield call(apiFetchAdminLinks)
    yield put(fetchAdminLinks.success(response))
  } catch (error) {
    console.log(error)
    // yield put(fetchAdminLinks.failure(error.message || error.error))
  }
}
function* fetchUserLinksWorker(action) {
  try {
    const response = yield call(apiFetchUserLinks, action.user)
    yield put(fetchUserLinks.success(response))
  } catch (error) {
    console.log(error)
  }
}

export function* addUserLinkWorker(action) {
  try {
    const response = yield call(addUserLinkApi, action.data)
    yield put(addUserLink.success(response))
  } catch (error) {
    console.log(error)
    // yield put(addUserLink.failure(error.message || error.error))
  }
}
export function* updateUserLinkWorker(action) {
  try {
    const response = yield call(updateUserLinkApi, action.data)
    yield put(updateUserLink.success(response))
  } catch (error) {
    console.log(error)
    // yield put(addUserLink.failure(error.message || error.error))
  }
}
export function* deleteUserLinkWorker(action) {
  try {
    const response = yield call(deleteUserLinkApi, action.data)
    yield put(deleteUserLink.success(response))
  } catch (error) {
    console.log(error)
    // yield put(addUserLink.failure(error.message || error.error))
  }
}

export default function* rootSaga() {
  yield takeLatest(FETCH_ADMIN_LINKS.REQUEST, fetchAdminLinksWorker)
  yield takeLatest(FETCH_USER_LINKS.REQUEST, fetchUserLinksWorker)
  yield takeLatest(ADD_USER_LINK.REQUEST, addUserLinkWorker)
  yield takeLatest(DELETE_USER_LINK.REQUEST, deleteUserLinkWorker)
  yield takeLatest(UPDATE_USER_LINK.REQUEST, updateUserLinkWorker)
}
